import classNames from "../../lib/classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./Column.module.css";

const mediumClassNames = [
    styles.medium1,
    styles.medium2,
    styles.medium3,
    styles.medium4,
    styles.medium5,
    styles.medium6,
    styles.medium7,
    styles.medium8,
];

const mediumOffsetClassNames = [
    styles.mediumOffset1,
    styles.mediumOffset2,
    styles.mediumOffset3,
    styles.mediumOffset4,
    styles.mediumOffset5,
    styles.mediumOffset6,
    styles.mediumOffset7,
    styles.mediumOffset8,
];

const mediumPushClassNames = [
    styles.mediumPush1,
    styles.mediumPush2,
    styles.mediumPush3,
    styles.mediumPush4,
    styles.mediumPush5,
    styles.mediumPush6,
    styles.mediumPush7,
    styles.mediumPush8,
];

const mediumPullClassNames = [
    styles.mediumPull1,
    styles.mediumPull2,
    styles.mediumPull3,
    styles.mediumPull4,
    styles.mediumPull5,
    styles.mediumPull6,
    styles.mediumPull7,
    styles.mediumPull8,
];

const largeClassNames = [
    styles.large1,
    styles.large2,
    styles.large3,
    styles.large4,
    styles.large5,
    styles.large6,
    styles.large7,
    styles.large8,
    styles.large9,
    styles.large10,
    styles.large11,
    styles.large12,
];

const largeOffsetClassNames = [
    styles.largeOffset1,
    styles.largeOffset2,
    styles.largeOffset3,
    styles.largeOffset4,
    styles.largeOffset5,
    styles.largeOffset6,
    styles.largeOffset7,
    styles.largeOffset8,
    styles.largeOffset9,
    styles.largeOffset10,
    styles.largeOffset11,
    styles.largeOffset12,
];

const largePushClassNames = [
    styles.largePush1,
    styles.largePush2,
    styles.largePush3,
    styles.largePush4,
    styles.largePush5,
    styles.largePush6,
    styles.largePush7,
    styles.largePush8,
    styles.largePush9,
    styles.largePush10,
    styles.largePush11,
    styles.largePush12,
];

const largePullClassNames = [
    styles.largePull1,
    styles.largePull2,
    styles.largePull3,
    styles.largePull4,
    styles.largePull5,
    styles.largePull6,
    styles.largePull7,
    styles.largePull8,
    styles.largePull9,
    styles.largePull10,
    styles.largePull11,
    styles.largePull12,
];

function clamp(index, arr) {
    if (index < 0) {
        return 0;
    } else if (index >= arr.length) {
        return arr.length - 1;
    }

    return index;
}

function mediumClassName(num) {
    const i = clamp(num - 1, mediumClassNames);
    return mediumClassNames[i];
}

function mediumOffsetClassName(num) {
    if (num === 0) {
        return null;
    }

    const i = clamp(num - 1, mediumOffsetClassNames);
    return mediumOffsetClassNames[i];
}

function mediumPushClassName(num) {
    if (num === 0) {
        return null;
    }

    const i = clamp(num - 1, mediumPushClassNames);
    return mediumPushClassNames[i];
}

function mediumPullClassName(num) {
    if (num === 0) {
        return null;
    }

    const i = clamp(num - 1, mediumPullClassNames);
    return mediumPullClassNames[i];
}

function largeClassName(num) {
    const i = clamp(num - 1, largeClassNames);
    return largeClassNames[i];
}

function largeOffsetClassName(num) {
    if (num === 0) {
        return null;
    }

    const i = clamp(num - 1, largeOffsetClassNames);
    return largeOffsetClassNames[i];
}

function largePushClassName(num) {
    if (num === 0) {
        return null;
    }

    const i = clamp(num - 1, largePushClassNames);
    return largePushClassNames[i];
}

function largePullClassName(num) {
    if (num === 0) {
        return null;
    }

    const i = clamp(num - 1, largePullClassNames);
    return largePullClassNames[i];
}

export default function Column(props) {
    const finalClassName = classNames(
        styles.column,
        mediumClassName(props.medium),
        mediumOffsetClassName(props.mediumOffset),
        mediumPushClassName(props.mediumPush),
        mediumPullClassName(props.mediumPull),
        largeClassName(props.large),
        largeOffsetClassName(props.largeOffset),
        largePushClassName(props.largePush),
        largePullClassName(props.largePull),
        props.className,
    );

    return <div className={finalClassName}>{props.children}</div>;
}

Column.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    large: PropTypes.number.isRequired,
    largeOffset: PropTypes.number.isRequired,
    largePull: PropTypes.number.isRequired,
    largePush: PropTypes.number.isRequired,
    medium: PropTypes.number.isRequired,
    mediumOffset: PropTypes.number.isRequired,
    mediumPull: PropTypes.number.isRequired,
    mediumPush: PropTypes.number.isRequired,
};

Column.defaultProps = {
    large: 12,
    largeOffset: 0,
    largePull: 0,
    largePush: 0,
    medium: 8,
    mediumOffset: 0,
    mediumPull: 0,
    mediumPush: 0,
};
